import { serverEnv } from './env'

// The allowlist is the whole access-control model for the admin area: there is no registration,
// no roles and no invitations, so an address is either on this list or it has no way in.
// Kept in core (not in the auth entrypoint) because the login route, the magic-link sender and
// the admin page all need the same answer, and three copies of this rule would eventually
// disagree. The parsing is a pure function so it can be tested without touching process.env.

export function parseAllowlist(raw: string | undefined): string[] {
  if (!raw) return []
  return raw
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)
}

export function matchesAllowlist(email: string, list: string[]): boolean {
  // an empty list means "nobody", never "everybody" - a missing env var must not open the door
  if (list.length === 0) return false
  return list.includes(email.trim().toLowerCase())
}

export function adminAllowlist(): string[] {
  return parseAllowlist(serverEnv().ADMIN_EMAIL_ALLOWLIST)
}

export function isAdminEmail(email: string): boolean {
  return matchesAllowlist(email, adminAllowlist())
}
